/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    compact: { type: 'variant', values: [ true ] },
    mini: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { compact: true },
      tokens: {
        contentPaddingBottom: 16,
        contentPaddingLeft: 24,
        contentPaddingRight: 0,
        contentPaddingTop: 8
      }
    },
    {
      if: { mini: true },
      tokens: {
        contentPaddingBottom: 0,
        contentPaddingLeft: 0,
        contentPanelPaddingBottom: 0,
        contentPanelPaddingTop: 0
      }
    }
  ],
  tokens: {
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 0,
    borderWidth: 0,
    collapseDuration: 250,
    contentPaddingBottom: 16,
    contentPaddingLeft: 24,
    contentPaddingRight: 0,
    contentPaddingTop: 0,
    contentPanelBackgroundColor: 'rgba(0, 0, 0, 0)',
    contentPanelBorderColor: 'rgba(0, 0, 0, 0)',
    contentPanelBorderWidth: 0,
    contentPanelFontColor: '#2c2e30',
    contentPanelFontName: 'HelveticaNow',
    contentPanelFontSize: 16,
    contentPanelFontWeight: '700',
    contentPanelLineHeight: 1.5,
    contentPanelPaddingBottom: 16,
    contentPanelPaddingLeft: 24,
    contentPanelPaddingRight: 0,
    contentPanelPaddingTop: 16,
    expandDividerColor: 'rgba(0, 0, 0, 0)',
    expandDividerWidth: 0,
    expandDuration: 300,
    marginBottom: 0
  }
}
export default theme
